import React from 'react'
import { StarIcon } from '../../UI/Icons/Icons'

function RatingIcon({
  fillColor = '#43927C',
  size,
  index,
  rating,
  hoverRating,
  onMouseEnter,
  onMouseLeave,
  onSaveRating,
}) {
  const fill = React.useMemo(() => {
    if (hoverRating >= index) {
      return fillColor
    } else if (!hoverRating && rating >= index) {
      return fillColor
    }
    return '#C4C4C4'
  }, [fillColor, rating, hoverRating, index])
  //
  if (onSaveRating) {
    return (
      <div
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={() => onMouseLeave()}
        onClick={() => onSaveRating(index)}
      >
        <StarIcon strokeColor={fill} size={size} />
      </div>
    )
  } else {
    return <StarIcon size={size} strokeColor={fill} />
  }
}
export default RatingIcon
